<div class="form-group">
  <label class="form-group__label">What is the square meters of your house?</label>
  <div class="input-wrap">
        <input
            type="number"
            [id]="uniqueId"
            [name]="uniqueControlName"
            [placeholder]=""
            [(ngModel)]="squareMeterValue"
            (ngModelChange)="onInputChange()"
            min="0"
            class="form-control"
            autocomplete="new-value"
        />
        <div class="input-wrap-append">
            <div class="input-wrap-symbol">
                m<sup>2</sup>
            </div> 
        </div>
    </div>
</div>

<div class="form-group"> 

  <label class="form-group__label">What kind of finishes does your house have?</label>
  <label class="selection">                                
      <input type="radio" name="radio-standard" 
           [value]="1"
           [(ngModel)]="finishingValue"
           [checked]="finishingValue === 1"
           (ngModelChange)="onInputChange()">
      <div class="selection__inner">
          <div class="selection__main">
              <div class="selection__content">
                  <div class="selection__indi"><span></span></div>                                        
                  <div class="selection__label">
                      <div class="selection__title">Standard Finishes</div>                                                    
                  </div>
              </div>                                     
          </div>
      </div>
  </label>
  <label class="selection">                                
      <input type="radio" name="radio-mid-range" 
           [value]="2"
           [(ngModel)]="finishingValue"
           [checked]="finishingValue === 2"
           (ngModelChange)="onInputChange()">
      <div class="selection__inner">
          <div class="selection__main">
              <div class="selection__content">
                  <div class="selection__indi"><span></span></div>                                        
                  <div class="selection__label">
                      <div class="selection__title">Mid-Range Finishes</div>                                                    
                  </div>
              </div>                                     
          </div>
      </div>
  </label>
  <label class="selection">                                
      <input type="radio" name="radio-high-end" 
           [value]="3"
           [(ngModel)]="finishingValue"
           [checked]="finishingValue === 3"
           (ngModelChange)="onInputChange()">
      <div class="selection__inner">
          <div class="selection__main">
              <div class="selection__content">
                  <div class="selection__indi"><span></span></div>                                        
                  <div class="selection__label">
                      <div class="selection__title">High-End Finishes</div>                                                    
                  </div>
              </div>                                     
          </div>
      </div>
  </label>

</div>
